export default "__VITE_ASSET__CtJ5gUE7__"